import { jsx as _jsx } from "react/jsx-runtime";
import Box from "@material-ui/core/Box";
import { useTheme } from "@material-ui/core";
const ColoredStatus = ({ rowData, loadedData, statusKey, ...props }) => {
    const theme = useTheme();
    const status = rowData[statusKey];
    const statusColor = theme.palette?.status?.[status];
    const contrastText = statusColor && theme.palette?.getContrastText(statusColor);
    return (_jsx(Box, { borderRadius: "100px", p: 0.5, fontSize: 10, color: contrastText, textAlign: "center", bgcolor: `status.${status}`, ...props, children: props.children && props.children.toString().toLocaleUpperCase() }));
};
export default ColoredStatus;
//# sourceMappingURL=ColoredStatus.js.map